import axios from 'axios';
const BASE_URL = process.env.REACT_APP_ROOT_URL;
//const BASE_URL =  '/api';

 
export const axiosPrivate = axios.create({
    baseURL: BASE_URL,
    timeout: 60000,
    headers: {
      "Cache-Control": "no-cache",'Content-Type': 'application/json'
    },
    withCredentials: true,
    showSnackbarOnSuccess: null,
    showSnackbarOnError: true,
});


export default {
    getUserLogin: (jwt) =>
    axiosPrivate({
        'method':'GET',
        'url':'/auth/user', 
        headers: {
          'Authorization': 'Bearer '+ jwt,
        }, 
        
    }),
    getUser: () =>
    axiosPrivate({
        'method':'GET',
        'url':'/auth/user', 

    }),
    verify: () =>
    axiosPrivate({
        'method':'GET',
        'url':'/auth/verify'
    }),
    
    checkSignature: (data) =>
    axiosPrivate({
        'method':'POST',
        'url': '/service/esdb/verify_signature',
        'data': data,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },

    }),
    sendFilesFas: (data) =>
    axiosPrivate({
        timeout: 240_000,
        'method':'POST',
        'url': '/service/esdb/create/fas',
        'data': data,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        'showSnackbarOnSuccess': "Fas enviado y firmado",

    }),
    sendFilesFus: (data) =>
      axiosPrivate({
          timeout: 240_000,
          'method':'POST',
          'url':'/service/esdb/create/fus',
          'data': data,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          'showSnackbarOnSuccess': "Fus enviado y firmado",
  
      }),
    sendFilesContingencias: (data) =>
      axiosPrivate({
          timeout: 240_000,
          'method':'POST',
          'url':'/service/esdb/create/contingencias',
          'data': data,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          'showSnackbarOnSuccess': "Contingencia enviada y firmada",
      }),
    sendFilesPeriodoGracia: (data) =>
      axiosPrivate({
          timeout: 240_000,
          'method':'POST',
          'url':'/service/esdb/create/periodo_gracia',
          'data': data,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          'showSnackbarOnSuccess': "Periodo de gracia enviado y firmada",
      }),
    overwriteFilesContingencias: (data, id) =>
      axiosPrivate({
          timeout: 240_000,
          'method':'POST',
          'url':'/service/esdb/overwrite/contingencias/'+id,
          'data': data,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          'showSnackbarOnSuccess': "Contingencia enviada y firmada",
      }),
    overwriteFilesFas: (data, id) =>
      axiosPrivate({
          timeout: 240_000,
          'method':'POST',
          'url':'/service/esdb/overwrite/fas/'+id,
          'data': data,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          'showSnackbarOnSuccess': "Contingencia enviada y firmada",
      }),
    sendFilesApelacion: (data, type) =>
      axiosPrivate({
          timeout: 240_000,
          'method':'POST',
          'url':'/service/esdb/create/'+type,
          'data': data,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          'showSnackbarOnSuccess': "Apelación enviada y firmada",
      }),
      getAllOperadores: () =>
      axiosPrivate({
          'method':'GET',
          'url':'/service/admin/get_operadores/',
          showSnackbarOnError: false,
      }),
      getZonas: () =>
      axiosPrivate({
          'method':'GET',
          'url':'/service/cedb/zona_autocomplete/',
          showSnackbarOnError: false,
      }),
      getAllZonas: () =>
      axiosPrivate({
          'method':'GET',
          'url':'/service/cedb/zonas/',
          showSnackbarOnError: false,
      }),

      putOficiosRBD: (data) =>
      axiosPrivate({
          'method':'POST',
          'url':'/service/cedb/oficios_rbd/',
          data: data,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          showSnackbarOnError: false,
        'showSnackbarOnSuccess': "Operación exitosa",
      }),

    postDocumentosOperador: (formData) =>
      axiosPrivate({
        method: "POST",
        url: "/service/cedb/operadores/documentos",
        data: formData,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        showSnackbarOnSuccess: "Operación exitosa",
      }),

      getZonasOperador: (id) =>
      axiosPrivate({
          'method':'GET',
          'url':'/service/cedb/zonas_por_operador/'+id,
          showSnackbarOnError: false,
      }),

      getAlarmas: () =>
      axiosPrivate({
          'method':'GET',
          'url':'/service/cedb/get_all_alarmas/',
          showSnackbarOnError: false,
      }),

      getAlarma: (id) =>
      axiosPrivate({
          'method':'GET',
          'url':'/service/cedb/get_alarmas_id/'+id,
          showSnackbarOnError: false,
      }),
      downloadReports: (docsId) =>
        axiosPrivate({
            method: 'POST',
            url: `/service/cedb/download_documentos_zip/`,
            data: docsId,
            headers: {
                'Content-Type': 'application/json',
            },
            responseType: 'blob',
        }),
      downloadDocuments: (docType, docsId) =>
        axiosPrivate({
            method: 'POST',
            url: `/service/esdb/download_documents/${docType}`,
            data: docsId,
            headers: {
                'Content-Type': 'application/json',
            },
            responseType: 'blob',
        }),
    getContingenciasData: (rut) =>
      axiosPrivate({
        timeout: 60_000,
        'method':'GET',
        'url':'/service/cedb/get_contingencias_by_rut/'+rut, 
        showSnackbarOnError: false,
    }),
    getContingenciasPendientesData: (rut) =>
      axiosPrivate({
        timeout: 60_000,
        'method':'GET',
        'url':'/service/cedb/get_contingencias_pendientes_by_rut/'+rut, 
        showSnackbarOnError: false,
    }),
    getContingencia: (id) =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/cedb/get_contingencias_by_id/'+id, 
        showSnackbarOnError: false,
    }),
    getContingenciaFirma: (id) =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/cedb/get_firmas_contingencia/'+id, 
        showSnackbarOnError: false,
    }),
    getFasFusInfo: (rbd) =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/cedb/velocidades_fas_pactado/'+rbd+'/', 
        showSnackbarOnError: false,
    }),
    getEesData: (rbd, jwt) =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/cedb/info_ees_fas/'+rbd+'/'+jwt+'', 
        showSnackbarOnError: false,
    }),
      rejectDoc: (doc_type, id, data) =>
      axiosPrivate({
          'method':'POST',
          'url':'/service/esdb/reject/'+doc_type+'/'+id,
          'data': data,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          'showSnackbarOnSuccess': "Documento rechazado correctamente",
  
      }),
      rejectDocSubtel: (doc_type, id, data) =>
      axiosPrivate({
          'method':'POST',
          'url':'/service/esdb/reject_subtel/'+doc_type+'/'+id,
          'data': data,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          'showSnackbarOnSuccess': "Documento rechazado correctamente",
  
      }),
      rejectDocMineduc: (doc_type, id, data) =>
      axiosPrivate({
          'method':'POST',
          'url':'/service/esdb/reject_mineduc/'+doc_type+'/'+id,
          'data': data,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          'showSnackbarOnSuccess': "Documento rechazado correctamente",
  
      }),
      rejectDocOperador: (doc_type, id, data) =>
      axiosPrivate({
          'method':'POST',
          'url':'/service/esdb/reject_operador/'+doc_type+'/'+id,
          'showSnackbarOnSuccess': "Documento rechazado correctamente",
  
      }),
      signDoc: (doc_type, id, data) =>
      axiosPrivate({
          timeout: 240_000,
          'method':'POST',
          'url':'/service/esdb/sign_document/'+doc_type+'/'+id,
          'data': data,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          'showSnackbarOnSuccess': "Documento firmado correctamente",
  
      }),
      getEesByRut: (rut) =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/cedb/info_ees_por_rrpp_ees/'+rut, 
        showSnackbarOnError: false,
    }),
    getEes: (rbd) =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/cedb/ees/'+rbd, 
        showSnackbarOnError: false,
    }),
    getEesParque: (rbd) =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/cedb/buscar_estado_parque/'+rbd+"/1", 
        showSnackbarOnError: false,
    }),
    getEesRectificacion: (rbd) =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/cedb/estado_parque_rectificacion_rbd/'+rbd, 
        showSnackbarOnError: false,
    }),
    getEstadoConvocatoria: (rbd) =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/cedb/get_estado_convocatoria/'+rbd+'/', 
        showSnackbarOnError: false,
    }),
    putBajaByRBD: (rbd, data) =>
      axiosPrivate({
        'method':'PUT',
        'url':'/service/cedb/dar_de_baja_ees/'+rbd+"?jwt_token=1", 
        data: data, 
        showSnackbarOnError: false,
        'showSnackbarOnSuccess': "Operación exitosa",
    }),
    updateTechByZone: (rbd, tech_id) =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/cedb/update_tecnologia_by_zona/'+rbd+"/"+tech_id, 
        'showSnackbarOnSuccess': "Operación exitosa",
        showSnackbarOnError: false,
    }),
    updateTechByRBD: (rbd, tech_id) =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/cedb/update_tecnologia_by_rbd/'+rbd+"/"+tech_id, 
        showSnackbarOnError: false,
    }),
    getParque: (rbd) =>
    axiosPrivate({
      method: 'GET',
      url:
        '/service/cedb/endpoint_parque2/' +
        (rbd != null ? rbd : ''),
      showSnackbarOnError: false,
    }),
    getParqueDetalle: (id_operador) =>
    axiosPrivate({
      method: 'GET',
      url:
        '/service/admin/get_rrpp_ees_ventana' +
        (id_operador != null ? '?id_operador='+id_operador : ''),
      showSnackbarOnError: false,
    }),
    getOperadores: () =>
    axiosPrivate({
      method: 'GET',
      url: '/service/admin/get_operadores/',
      showSnackbarOnError: false,
    }),
  getHistorialReportes: (id_operador) =>
    axiosPrivate({
      method: "GET",
      url: id_operador
        ? `/service/reportes/resumen_operadores?id_operador=${encodeURIComponent(id_operador)}`
        : "/service/reportes/resumen_operadores",
      showSnackbarOnError: false,
    }),

      
    putEesInfo: (rbd, data) =>
      axiosPrivate({
        'method':'PUT',
        'url':'/service/cedb/modificar_info_ees/'+rbd, 
        'data': data,
        'showSnackbarOnError': false,
        'showSnackbarOnSuccess': "Operación exitosa",
    }), 
    createTicket: (data) =>
      axiosPrivate({
        'method':'POST',
        'url':'/service/esdb/create_ticket', 
        'data': data,
        showSnackbarOnError: false,
        'showSnackbarOnSuccess': "Ticket de soporte creado con éxito",
    }),
    getUUID: (uuid) =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/ardb/'+uuid,
    }),
    getUUIDReporte: (uuid_reporte) =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/cedb/reporte_batch/'+uuid_reporte,
    }),
    getUserRBD: (rut) =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/cedb/usuarios_ees/'+rut, 
    }),
    getRBD: (rbd) =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/cedb/rbd_autocomplete/'+rbd, 
    }),
    getRBDOperador: (rbd, operador) =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/cedb/rbd_autocomplete_operador/'+rbd+'/'+operador,
    }),
    getRBDOperadorFacturando: (rbd, operador) =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/cedb/rbd_autocomplete_operador_facturando/'+rbd+'/'+operador,
    }),

    changeAddresStatus : (rbd,data) =>
      axiosPrivate({
        'method':'POST',
        'url':'/service/cedb/cambiar_estado_direccion/'+rbd, 
        'data': data,
        'showSnackbarOnSuccess': "Estado de dirección actualizado"
    }),

    getEesInfo: (id) =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/cedb/ees/'+id, 
    }),
    getFas: (id) =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/cedb/fas/'+id, 
        showSnackbarOnError: false,
    }),
    getFus: (id) =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/cedb/fus/'+id, 
        showSnackbarOnError: false,

    }),
    getFasList: (rut) =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/cedb/fas_endpoint_no_firma/'+rut+'/1', 
    }),
    getFasFirma: (id) =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/cedb/get_firmas_fas/'+id+'/', 
        showSnackbarOnError: false,
    }),
    getFusList: (rut) =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/cedb/fus_endpoint_no_firma/'+rut+'/1', 
    }),
    getFusFirma: (id) =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/cedb/get_firmas_fus/'+id+'/', 
        showSnackbarOnError: false,
    }),
    getOperator: (rut) =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/cedb/operador_por_operador_instalador/'+rut, 
    }),
    getTechTypes: () =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/cedb/tipos_tecnologia/', 
    }),
    updateDescuentoPrefactura: (id_operador, periodo, version, data) =>
      axiosPrivate({
        'method':'PUT',
        'url':'/service/esdb/update_descuentos_prefactura/'+id_operador+'/'+periodo+'/'+version, 
        'data': data,
        'showSnackbarOnSuccess': "Descuento actualizado"
    }),
    updateAbonosPrefactura: (id_operador, periodo, version, data) =>
      axiosPrivate({
        'method':'PUT',
        'url':'/service/esdb/update_abonos_prefactura/'+id_operador+'/'+periodo+'/'+version, 
        'data': data,
        'showSnackbarOnSuccess': "Abono actualizado"
    }),
    getPrefacturas: (periodo) =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/cedb/prefacturas/completas/'+periodo, 
    }),
    getPrefacturasV2: (periodo) =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/esdb/prefactura/'+periodo, 
    }),
    getDevengos: (periodo) =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/cedb/devengos/completas/'+periodo, 
        showSnackbarOnError: false,
    }),
    getPrefacturasCompletas: () =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/cedb/prefacturas/completas_periodos/', 
    }),
    getPrefacturasCompletasHistorial: () =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/cedb/prefacturas/completas_periodos_historial/', 
    }),
    getPrefacturasRBD: (periodo) =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/cedb/list_info_prefactura_rbd_periodo/'+periodo, 
    }),
    getPrefacturaByOperador: (id, periodo) =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/cedb/endpoint_operador_administrador_por_operador/'+id+'/'+periodo, 
        showSnackbarOnError: false,
    }),
      acceptPrefactura: (id) =>
      axiosPrivate({
          'method':'POST',
          'url':'/service/esdb/accept_prefactura/'+id,

      }),
    getPrefactura: (query) =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/cedb/endpoint_operador_administrador/'+query, 
    }),
    getApelaciones: (rut) =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/cedb/apelaciones_endpoint_firmas/'+rut, 
    }),
    getApelacion: (query) =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/cedb/apelaciones_endpoint/'+query, 
    }),
    getDiferenciasOperadorPeriodo: (periodo) =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/esdb/get_diferences/'+periodo, 
    }),

    getReportesComerciales: (query) =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/cedb/reportes_comerciales/'+query, 
    }),
    putConfigUser: (rut, data) =>
      axiosPrivate({
        'method':'PUT',
        'url':'/service/cedb/configuracion_usuario/'+rut, 
        'data': data,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        'showSnackbarOnSuccess': "Operación exitosa",
    }),
    putConfigUserSign: (rut, data) =>
      axiosPrivate({
        'method':'PUT',
        'url':'/service/cedb/configuracion_usuario/'+rut+'/firma',
        'data': data,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
    }),
    getCode: (id) =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/cedb/endpoint_generar_uuid/'+id, 
        showSnackbarOnError: false,
    }),
    getRepresentantes: (rbd) =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/cedb/list_representantes_ees/'+rbd, 
        showSnackbarOnError: false,
    }),
    changePredeterminado: (rut, rbd) =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/cedb/change_representante_predeterminado/'+rut+'/'+rbd, 
        showSnackbarOnError: false,
    }),
    deleteRepresentante: (data) =>
      axiosPrivate({
        'method':'POST',
        'data': data,
        'url':'/service/cedb/eliminar_representante_ees/', 
        showSnackbarOnError: false,
    }),
    addRepresentante: (data) =>
      axiosPrivate({
        'method':'POST',
        'data': data,
        'url':'/service/cedb/agregar_representante_ees/', 
        showSnackbarOnError: false,
    }),
    massiveApproval: (doc_type, data) =>
      axiosPrivate({
        timeout: 240_000,
        'method':'POST',
        'data': data,
        'url':'/service/esdb/sign_documents_by_ids/'+doc_type, 
        showSnackbarOnError: false,
    }),
    massiveRejection: (doc_type, data) =>
      axiosPrivate({
        timeout: 240_000,
        'method':'POST',
        'data': data,
        'url':'/service/esdb/reject_documents_by_ids/'+doc_type, 
        showSnackbarOnError: false,
    }),
    getByConvocatoria: () =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/cedb/get_convocatoria_full/', 
        showSnackbarOnError: false,
    }),
    getReport: (report) =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/reportes/'+report, 
        showSnackbarOnError: false,
    }),
    getConteoMensual: () =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/reportes/conteo_mensual', 
        showSnackbarOnError: false,
    }),

      
    listRepresentantes: () =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/cedb/list_representantes/', 
        showSnackbarOnError: false,
    }),
    temporalToRepresentante: (rut, rbd) =>
      axiosPrivate({
        'method':'GET',
        'url':'service/cedb/change_representante_temporal/'+rut+'/'+rbd, 
        showSnackbarOnError: false,
    }),
    disableRepresentante: (rut, rbd) =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/cedb/change_representante_deshabilitar/'+rut+'/'+rbd,
    }),
    enableRepresentante: (rut, rbd) =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/cedb/change_representante_rehabilitar/'+rut+'/'+rbd, 
        showSnackbarOnError: false,
    }),
    getAltaBajaInfoRBD: (rbd) =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/cedb/get_fechas_alta_baja/'+rbd+'/', 
        showSnackbarOnError: false,
    }),


    getResumenIntentosRBD: (rbd) =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/cedb/resumen_direccion/'+rbd, 
        showSnackbarOnError: false,
    }),

      registrarDireccionRBD: (rbd, data) =>
      axiosPrivate({
        'method':'POST',
        'data': data,
        'url':'/service/cedb/registar_direccion/'+rbd, 
    }),
      getDireccionesRBD: () =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/cedb/resumen_direcciones', 
        showSnackbarOnError: false,
    }),
      getOficioRectificacionDetalle: (numero_oficio, tipo_oficio) =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/cedb/get_oficio/?numero_oficio='+numero_oficio+'&tipo_oficio='+tipo_oficio, 
        showSnackbarOnError: false,
    }),



      getAdminHealth: () =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/admin/health', 
        showSnackbarOnError: false,
    }),
      getAdminUserData: (rut) =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/esdb/get_user_admin_info/'+rut,
    }),
      getOperadoresUsuarios: () =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/esdb/usuarios/operadores',
    }),
      getBajasPorOperador: () =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/admin/bajas_grouped/?fecha_desde=2025-01-01', 
    }),
      getInicioObrasPorOperador: () =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/admin/recepcion_obra/?fecha_desde=2025-01-01', 
    }),
      getInicioServicioPorOperador: () =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/admin/altas_grouped/?fecha_desde=2025-01-01', 
    }),
      addNya: (data) =>
      axiosPrivate({
        'method':'POST',
        'data': data,
        'url':'/service/admin/agregar_nya/', 
    }),
      getPeriodosGracia: (id_operador, periodo) =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/esdb/periodos-gracia/'+id_operador+'?periodo='+periodo, 
    }),
      getOficioPorTipos: (tipo_oficio) =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/cedb/get_oficios_por_tipo/?tipo_oficio='+tipo_oficio,
    }),
      getOficiosHistorial: () =>
      axiosPrivate({
        'method':'GET',
        'url':'/service/reportes/get_data_oficios',
        showSnackbarOnError: false,
    }),

    getStatsRbdAgregado: ({ granularidad, dimension, fecha_inicio, fecha_fin, id_operador, id_zona, rbd, tipo_tecnologia } = {}) =>
      axiosPrivate({
        method: 'GET',
        url: '/service/reportes/stats-rbd/agregado',
        params: {
          granularidad,
          dimension,
          fecha_inicio,
          fecha_fin,
          ...(id_operador != null ? { id_operador } : {}),
          ...(id_zona      != null ? { id_zona }      : {}),
          ...(rbd          != null ? { rbd }           : {}),
          ...(tipo_tecnologia != null ? { tipo_tecnologia } : {}),
        },
        showSnackbarOnError: false,
      }),

    getSupervisionCQ: ({ granularidad, dimension, fecha_inicio, fecha_fin, id_operador, id_zona, rbd, tipo_tecnologia } = {}) =>
      axiosPrivate({
        method: 'GET',
        url: '/service/reportes/supervision/cq',
        params: {
          granularidad,
          dimension,
          fecha_inicio,
          fecha_fin,
          ...(id_operador != null ? { id_operador } : {}),
          ...(id_zona      != null ? { id_zona }      : {}),
          ...(rbd          != null ? { rbd }           : {}),
          ...(tipo_tecnologia != null ? { tipo_tecnologia } : {}),
        },
        showSnackbarOnError: false,
      }),

    getRbdSinMovimiento: ({ fecha_inicio, fecha_fin } = {}) =>
      axiosPrivate({
        method: 'GET',
        url: '/service/reportes/subida_y_bajada_cero/resumen',
        params: { fecha_inicio, fecha_fin },
        showSnackbarOnError: false,
      }),

    getMonitoreoPrefacturaResumen: ({ periodo, id_operador } = {}) =>
      axiosPrivate({
        method: 'GET',
        url: '/service/esdb/monitoreo/prefactura/resumen',
        params: {
          periodo,
          ...(id_operador != null ? { id_operador } : {}),
        },
        showSnackbarOnError: false,
      }),

    getMonitoreoPrefacturaConteos: ({ periodo, codigos, id_operador } = {}) =>
      axiosPrivate({
        method: 'GET',
        url: '/service/esdb/monitoreo/prefactura/conteos',
        params: {
          periodo,
          codigos: Array.isArray(codigos) ? codigos.join(',') : codigos,
          ...(id_operador != null ? { id_operador } : {}),
        },
        showSnackbarOnError: false,
      }),

    getMonitoreoPrefacturaDetalle: ({ codigo, periodo, id_operador, limit, offset } = {}) =>
      axiosPrivate({
        method: 'GET',
        url: `/service/esdb/monitoreo/prefactura/detalle/${codigo}`,
        params: {
          periodo,
          ...(id_operador != null ? { id_operador } : {}),
          ...(limit != null ? { limit } : {}),
          ...(offset != null ? { offset } : {}),
        },
        showSnackbarOnError: false,
      }),

    getReporteContingencias: ({ periodo, id_operador, incluir_periodos_gracia } = {}) =>
      axiosPrivate({
        method: 'GET',
        url: '/service/esdb/reportes/contingencias/mensual',
        params: {
          periodo,
          ...(id_operador ? { id_operador } : {}),
          ...(incluir_periodos_gracia ? { incluir_periodos_gracia: true } : {}),
        },
        timeout: 300000,
        showSnackbarOnError: false,
      }),

    getReporteContingenciasPDF: ({ periodo, id_operador, incluir_periodos_gracia } = {}) =>
      axiosPrivate({
        method: 'GET',
        url: '/service/esdb/reportes/contingencias/mensual/pdf',
        params: {
          periodo,
          ...(id_operador ? { id_operador } : {}),
          ...(incluir_periodos_gracia ? { incluir_periodos_gracia: true } : {}),
        },
        responseType: 'blob',
        timeout: 300000,
        showSnackbarOnError: false,
      }),

    getReporteCalidad: ({ periodo, id_operador, ambito } = {}) =>
      axiosPrivate({
        method: 'GET',
        url: '/service/esdb/reportes/calidad/mensual',
        params: {
          periodo,
          ...(id_operador ? { id_operador } : {}),
          ...(ambito ? { ambito } : {}),
        },
        timeout: 300000,
        showSnackbarOnError: false,
      }),

    getReporteCalidadPDF: ({ periodo, id_operador, ambito } = {}) =>
      axiosPrivate({
        method: 'GET',
        url: '/service/esdb/reportes/calidad/mensual/pdf',
        params: {
          periodo,
          ...(id_operador ? { id_operador } : {}),
          ...(ambito ? { ambito } : {}),
        },
        responseType: 'blob',
        timeout: 300000,
        showSnackbarOnError: false,
      }),

    getZonasDevengo: () =>
      axiosPrivate({
        method: 'GET',
        url: '/service/esdb/zonas_devengo',
        showSnackbarOnError: false,
      }),

    getRBDDevengo: (rbd) =>
      axiosPrivate({
        method: 'GET',
        url: `/service/esdb/rbds_devengo/${rbd}`,
        showSnackbarOnError: false,
      }),

    getDevengosDetalle: ({ rbds, id_zona, analisis_fin, incluir_mes_siguiente } = {}) =>
      axiosPrivate({
        method: 'POST',
        url: '/service/esdb/devengos_detalle',
        data: {
          ...(id_zona != null && id_zona !== '' ? { id_zona } : {}),
          ...(rbds ? { rbds } : {}),
          ...(analisis_fin ? { analisis_fin } : {}),
          ...(incluir_mes_siguiente ? { incluir_mes_siguiente: true } : {}),
        },
        headers: { 'Content-Type': 'application/json' },
        timeout: 300000,
        showSnackbarOnError: false,
      }),

    getDevengosRBD: ({ rbds, analisis_fin } = {}) =>
      axiosPrivate({
        method: 'POST',
        url: '/service/esdb/get_devengos_rbd',
        data: {
          rbds,
          ...(analisis_fin ? { analisis_fin } : {}),
        },
        headers: { 'Content-Type': 'application/json' },
        responseType: 'blob',
        timeout: 300000,
        showSnackbarOnError: false,
      }),

    getDevengosZona: ({ id_zona, analisis_fin } = {}) =>
      axiosPrivate({
        method: 'GET',
        url: `/service/esdb/get_devengos_zona/${id_zona}`,
        params: {
          ...(analisis_fin ? { analisis_fin } : {}),
        },
        responseType: 'blob',
        timeout: 300000,
        showSnackbarOnError: false,
      }),

    getDevengosOficio: ({ id_oficio } = {}) =>
      axiosPrivate({
        method: 'GET',
        url: `/service/esdb/get_devengos_oficio/${id_oficio}`,
        timeout: 300000,
        showSnackbarOnError: false,
      }),

    exportPrefacturaSagec: ({ periodo, id_operador, force_overwrite } = {}) =>
      axiosPrivate({
        method: 'GET',
        url: '/service/esdb/export_prefactura_sagec',
        params: {
          periodo,
          ...(id_operador != null ? { id_operador } : {}),
          ...(force_overwrite ? { force_overwrite: true } : {}),
        },
        timeout: 900000,
        showSnackbarOnError: false,
      }),

    exportPrefacturaOperador: ({ periodo, id_operador } = {}) =>
      axiosPrivate({
        method: 'GET',
        url: '/service/esdb/export_prefactura_operador',
        params: {
          periodo,
          ...(id_operador != null ? { id_operador } : {}),
        },
        timeout: 900000,
        showSnackbarOnError: false,
      }),

    getEstadoStatsRbd: ({ fecha } = {}) =>
      axiosPrivate({
        method: 'GET',
        url: '/service/reportes/stats-rbd/estado',
        params: { fecha },
        showSnackbarOnError: false,
      }),

    calcularStatsRbd: ({ fecha, op_ids, festivos, modo, max_workers } = {}) =>
      axiosPrivate({
        method: 'POST',
        url: '/service/reportes/stats-rbd/calcular',
        data: {
          fecha,
          modo,
          ...(Array.isArray(op_ids) && op_ids.length ? { op_ids } : {}),
          ...(Array.isArray(festivos) && festivos.length ? { festivos } : {}),
          ...(max_workers != null ? { max_workers } : {}),
        },
        headers: { 'Content-Type': 'application/json' },
        timeout: 3600000,
        showSnackbarOnError: false,
      }),
}
